import { isString } from 'lodash';
export default function isComparable(subject) {
    return isString(subject) || !isNaN(+subject);
}
